import { render, staticRenderFns } from "./PartsListTable.vue?vue&type=template&id=58a1b33f&scoped=true"
import script from "./PartsListTable.vue?vue&type=script&lang=js"
export * from "./PartsListTable.vue?vue&type=script&lang=js"
import style0 from "./PartsListTable.vue?vue&type=style&index=0&id=58a1b33f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1b33f",
  null
  
)

export default component.exports